import { TaxRegionKey } from '@capintel/instruments-lib';

export const FIELD_KEYS = {
  [TaxRegionKey.US]: {
    SHORT_TERM_YTD_GAIN: 'shortTermYTDGain',
    SHORT_TERM_YTD_LOSS: 'shortTermYTDLoss',
    LONG_TERM_YTD_GAIN: 'longTermYTDGain',
    LONG_TERM_YTD_LOSS: 'longTermYTDLoss',
    SHORT_TERM_CARRIED_FORWARD_LOSS: 'shortTermCarriedForwardLoss',
    LONG_TERM_CARRIED_FORWARD_LOSS: 'longTermCarriedForwardLoss',
    SHORT_TERM_CAPITAL_GAINS_RATE: 'shortTermCapitalGainsRate',
    LONG_TERM_CAPITAL_GAINS_RATE: 'longTermCapitalGainsRate',
  },
  [TaxRegionKey.CA]: {
    YTD_GAIN: 'ytdGain',
    YTD_LOSS: 'ytdLoss',
    CARRY_FORWARD_LOSS: 'carryForwardLoss',
    MARGINAL_TAX_RATE: 'marginalTaxRate',
  },
} as const;

export const FIELD_LABEL_KEYS = {
  [TaxRegionKey.US]: {
    [FIELD_KEYS[TaxRegionKey.US].SHORT_TERM_YTD_GAIN]: 'Comparison.TaxAnalysis.ShortTermYTDGain',
    [FIELD_KEYS[TaxRegionKey.US].SHORT_TERM_YTD_LOSS]: 'Comparison.TaxAnalysis.ShortTermYTDLoss',
    [FIELD_KEYS[TaxRegionKey.US].LONG_TERM_YTD_GAIN]: 'Comparison.TaxAnalysis.LongTermYTDGain',
    [FIELD_KEYS[TaxRegionKey.US].LONG_TERM_YTD_LOSS]: 'Comparison.TaxAnalysis.LongTermYTDLoss',
    [FIELD_KEYS[TaxRegionKey.US].SHORT_TERM_CARRIED_FORWARD_LOSS]: 'Comparison.TaxAnalysis.ShortTermCarriedForwardLoss',
    [FIELD_KEYS[TaxRegionKey.US].LONG_TERM_CARRIED_FORWARD_LOSS]: 'Comparison.TaxAnalysis.LongTermCarriedForwardLoss',
    [FIELD_KEYS[TaxRegionKey.US].SHORT_TERM_CAPITAL_GAINS_RATE]: 'Comparison.TaxAnalysis.ShortTermCapitalGainsRate',
    [FIELD_KEYS[TaxRegionKey.US].LONG_TERM_CAPITAL_GAINS_RATE]: 'Comparison.TaxAnalysis.LongTermCapitalGainsRate',
  },
  [TaxRegionKey.CA]: {
    [FIELD_KEYS[TaxRegionKey.CA].YTD_GAIN]: 'Comparison.TaxAnalysis.YTDGain',
    [FIELD_KEYS[TaxRegionKey.CA].YTD_LOSS]: 'Comparison.TaxAnalysis.YTDLoss',
    [FIELD_KEYS[TaxRegionKey.CA].CARRY_FORWARD_LOSS]: 'Comparison.TaxAnalysis.CarryForwardLoss',
    [FIELD_KEYS[TaxRegionKey.CA].MARGINAL_TAX_RATE]: 'Comparison.TaxAnalysis.MarginalTaxRate',
  },
} as const;
